
.s-loading {
  animation: spin 1s linear infinite;
  fill: var(--color-primary)
}


.s-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
